module.exports = __webpack_public_path__ + "img/aa.301da27d.svg";